import PxoCreateForm                            from "./PxoCreateForm";
import { useEffect, useState }                  from 'react';
import { usePxoPage }                           from '../../contexts/PxoPageContext';
import { useUser }                              from '../../contexts/UserContext';
import api                                      from '../../services/api';
import dayjs                                    from 'dayjs';

export default function PxoCreateFormConteiner () {
    
    const { setIsFormPxoOpen, isFormPxoOpen, horizonTypes, handleUpdatePxoTables } = usePxoPage()
    const { userData } = useUser()

    const [__options,                   __setOptions                    ] = useState([]);     
    const [__selectedHorizonType,       __setSelectedHorizonType        ] = useState(null);
    const [__dateType,                  __setDateType                   ] = useState('default');
    const [__selectedDateForm,          __setSelectedDateForm           ] = useState(null);
    const [__horizonOfPlan,             __setHorizonOfPlan              ] = useState(null);
    const [__isSubmitting,              __setIsSubmitting               ] = useState(false);
    const [__errorMessage,              __setErrorMessage               ] = useState(null);

    //fill select options
    useEffect(() => {

        if(horizonTypes.length > 0){
            
            __setOptions(horizonTypes.map(item => ({ value: item.id, label: item.ownerHorizonOfPlan.name })))
            __setSelectedHorizonType(horizonTypes[0])
        }

    }, [horizonTypes])
    
    //change dateType based on selectOptions
    useEffect(() => {
        
        if(__selectedHorizonType){

            __setHorizonOfPlan(__selectedHorizonType.ownerHorizonOfPlan)
        }

    }, [__selectedHorizonType])

    const __onChangeSelect = (selectedValue) => {
        
        __setSelectedHorizonType(horizonTypes.find(item => item.id === selectedValue.value))
    }

  
    const handleSubmit = async () => {

        if(!__selectedDateForm || !__selectedHorizonType) return

        __setErrorMessage(null)
        __setIsSubmitting(true)
        
        try{

            const payload = {
                selectedDate: `${__selectedDateForm}`,
                pxoHorizonId: __selectedHorizonType.id,
                userId: userData.id
            }

            console.log('Enviando para /createPxo:', payload)

            const response = await api.post('/createPxo', payload)

            console.log('Resposta do /createPxo:', response)

            await new Promise(res => setTimeout(res, 3000))

            setIsFormPxoOpen(false)
            handleUpdatePxoTables()

        }catch(error){

            console.error('Erro completo:', error)
            console.error('Status:', error?.response?.status)
            console.error('Data:', error?.response?.data)

            const errorData = error?.response?.data
            const errorMessage = typeof errorData === 'string' ? errorData : errorData?.message
            __setErrorMessage(errorMessage || 'Não foi possível criar o PxO. Tente novamente.')

            // Importante: não chamar setIsFormPxoOpen(false) aqui —
            // o formulário deve permanecer aberto em caso de erro,
            // para que o usuário veja a mensagem e possa corrigir/tentar de novo.

        }finally{

            __setIsSubmitting(false)
        }
    }

    // PxoCreateFormConteiner.js
    // Reseta o erro sempre que o formulário é aberto,
    // evitando que uma mensagem de uma tentativa anterior "vaze" pra próxima sessão
    useEffect(() => {
        if (isFormPxoOpen) {
            __setErrorMessage(null)
        }
    }, [isFormPxoOpen])

    return(

        <PxoCreateForm 

            selectedDateType={__horizonOfPlan?.dateInputFilterFormat || 'year'} 

            isOpen={isFormPxoOpen} 
            onClose={() => {
                __setErrorMessage(null)
                setIsFormPxoOpen(false)
            }} 
            onSubmit={handleSubmit} 
            onChangeSelect={__onChangeSelect}
            selectValues={__options}

            onChangeDate={(date) => __setSelectedDateForm(date)}
            selectedDateForm={__selectedDateForm}

            isSubmitting={__isSubmitting}
            errorMessage={__errorMessage}

        />

    )
}